import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { TeamComponent } from './components/team/team.component';
import { CymiComponent } from './components/cymi/cymi.component';
import { NoticePress3Component } from './components/partners/notice-press3/notice-press3.component';
import { NoticePressComponent } from './components/partners/notice-press/notice-press.component';
import { NoticePress2Component } from './components/partners/notice-press2/notice-press2.component';
import { NoticePress4Component } from './components/partners/notice-press4/notice-press4.component';
import { NoticePress5Component } from './components/partners/notice-press5/notice-press5.component';
import { NoticePress6Component } from './components/partners/notice-press6/notice-press6.component';
import { NoticePress7Component } from './components/partners/notice-press7/notice-press7.component';
import { NoticePress8Component } from './components/partners/notice-press8/notice-press8.component';
import { NoticePress9Component } from './components/partners/notice-press9/notice-press9.component';
import { NoticePress10Component } from './components/partners/notice-press10/notice-press10.component';
import { NoticePress11Component } from './components/partners/notice-press11/notice-press11.component';
import { NoticePress12Component } from './components/partners/notice-press12/notice-press12.component';
import { NoticePress13Component } from './components/partners/notice-press13/notice-press13.component';
import { NoticePress14Component } from './components/partners/notice-press14/notice-press14.component';
import { NoticePress15Component } from './components/partners/notice-press15/notice-press15.component';
import { NoticePress16Component } from './components/partners/notice-press16/notice-press16.component';
import { NoticePress17Component } from './components/partners/notice-press17/notice-press17.component';
import { NoticePress18Component } from './components/partners/notice-press18/notice-press18.component';

import { Backing2Component } from './components/backing2/backing2.component';
import { OneComponent } from './components/one/one.component';
import { WoldAsOneComponent } from './components/wold-as-one/wold-as-one.component';
import { ImagineAppComponent } from './components/imagine-app/imagine-app.component';
import { RegisterReserveComponent } from './components/register-reserve/register-reserve.component';
import { GmixComponent } from './components/gmix/gmix.component';
import { StartFormComponent } from './components/start-form/start-form.component';
import { NoticePress25Component } from './components/partners/notice-press25/notice-press25.component';
import { NoticePress26Component } from './components/partners/notice-press26/notice-press26.component';





const routes: Routes = [
  // { path: 'home',
  //   component: ContentTabsComponent,
  //   children: [
  //     {
  //       path: 'home',
  //       loadChildren: './components/content-tabs/content-tabs/.component#ContentTabsComponent',
  //     },
  //   ],
  // },
  { path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    data: {animation: 'HomePage'}
  },
  { path: 'solutions',
    loadChildren: () => import('./modules/solutions/solutions.module').then(m => m.SolutionsModule),
    data: {animation: 'SolutionsPage'}
  },
  // { path: 'cryptmi',
  //   loadChildren: () => import('./modules/cryptmi/cryptmi.module').then(m => m.CryptmiModule),
  //   data: {animation: 'CryptmiPage'}
  {
    path: 'news/gennius-xyz-completes-acquisition-of-utoppia',
    component: NoticePress26Component,
    data: {
      animation: 'NoticePage',
      title: 'Gennius XYZ Completes Acquisition of Utoppia'
    }
  },
  // },
  { path: 'cymi',
    component: CymiComponent,
    data: {animation: 'CymiPage'}
  },
  { path: 'cymi-v2',
    loadChildren: () => import('./modules/cymi/cymi.module').then(m => m.CymiModule),
    data: {animation: 'CymiV2Page'}
  },

  { path: 'visa-client',
    loadChildren: () => import('./modules/visa-client/visa-client.module').then(m => m.VisaClientModule),
    data: {animation: 'VisaPage'}
  },
  { path: 'mena-region',
    loadChildren: () => import('./modules/mena-region/mena-region.module').then(m => m.MenaRegionModule),
    data: {animation: 'MenaPage'}
  },
  { path: 'about',
    component: Backing2Component,
    data: {animation: 'AboutPage'}
  },
  { path: 'team',
    component: TeamComponent,
    data: {animation: 'TeamPage'}
  },
  { path: 'news',
    loadChildren: () => import('./modules/news/news.module').then(m => m.NewsModule),
    data: {animation: 'NewsPage'}
  },
  { path: 'imagine',
    component: OneComponent,
    data: {animation: 'AboutPage'}
  },
  { path: 'gmix',
    component: GmixComponent,
    data: {animation: 'gmixPage'}
  },
  { path: 'the-world-as-one',
  component: WoldAsOneComponent,
  data: {animation: 'WorldPage'}
  },
  { path: 'imagine-app',
  component: ImagineAppComponent,
  data: {animation: 'ImaginePage'}
  },
  { path: 'lets-start-the-conversation',
    component: StartFormComponent,
    data: { animation: 'StartFormPage' }
  },
    { path: 'theWorldAsOne',
    component: RegisterReserveComponent,
    data: {animation: 'AboutPage'}
  },
  {
    path: 'news/novae-now-member-of-visa-fintech-partner-connect',
    component: NoticePress3Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },


  {
    path: 'news/the-best-thing-that-can-happen-to-you-since-takeoff',
    component: NoticePressComponent,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/novaes-voyage-connected-world-is-leveling-up-with-priceline-partner-networks',
    component: NoticePress2Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-unveils-revolutionary-cymi-utility-token-for-seamless-rewards-and-payments-interoperability-at-nexthon-v',
    component: NoticePress4Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/seed-group-onboards-gennius-xyz-to-transform-the-digital-asset-ecosystem-in-mena',
    component: NoticePress5Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/exciting-announcement-for-the-mexican-market',
    component: NoticePress6Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/welcome-luis',
    component: NoticePress7Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-and-consolid-global-announce-extended-partnership',
    component: NoticePress8Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-launched-its-gennius-global-hub-at-the-world-as-one-event',
    component: NoticePress9Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/we-are-delighted-to-announce-the-appointment-of-carolina-as-our-new-managing-director',
    component: NoticePress10Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/announcing-voyage-connected-world',
    component: NoticePress11Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-appoints-ruben-salazar-genovez-as-ceo-and-investor-to-drive-global-expansion',
    component: NoticePress12Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },

  {
    path: 'news/gennius-unveils-one-a-streamlined-solution-for-mid-sized-Loyalty-programs',
    component: NoticePress13Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-is-excited-to-announce-the-appointment-of-akshay-chopra',
    component: NoticePress14Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-appoints-laura-gabrysiak-gomez-as-vice-president-of-ai-and-analytics',
    component: NoticePress15Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  {
    path: 'news/gennius-xyz-appoints-oznur-demir-as-vice-president-of-global-marketing',
    component: NoticePress16Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },{
    path: 'news/gennius-xyz-appoints-ana-velasquez-as-managing-director-for-latin-america-&-caribbean',
    component: NoticePress17Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },{
    path: 'news/when-points-become-digital-assets-fuze-and-gennius-xyz-push-rewards-tokenization',
    component: NoticePress18Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },{
    path: 'news/gennius-XYZ-acquires-TripPromoter-to-launch-an-experiential',
    component: NoticePress25Component,
    data: {
      animation: 'NoticePage',
      title: 'novae | A new breed of digital payments'
    }
  },
  { path: '**',
    pathMatch: 'full',
    redirectTo: 'home'
  }
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      //preloadingStrategy: PreloadAllModules,
      enableTracing: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
